import { Link } from "react-router-dom"
import { Card, Flex, Heading, Image } from "@aws-amplify/ui-react";

export function FolderCard({
  folder
}: {
  folder : string
}) {
  const formatFolderName = (name : string) => {
    const match = name.match(/(?<year>[0-9]{4})-(?<month>[0-9]{2})-(?<day>[0-9]{2})_(?<event>.*)/)
    if (match == null || match.length < 5) return name
    let [raw, year, month, day, event, ...rest] = match
    event = event.replaceAll(/_/g, ' ')
    return `[${year}-${month}-${day}] ${event}`
  }
  
  return (
    <Card lineHeight="small" style={{ boxShadow: 'lightgrey 3px 4px 18px'}}>
      <Flex gap="xxs" direction="column">
        <Link to={`/gallery/${folder}`} style={{ textDecoration: 'none' }}>
          <Heading level={2} isTruncated={true}>
            {formatFolderName(folder)}
          </Heading>
        </Link>
      </Flex>
    </Card>
  );
}
